import { Icons } from "./icons";

export const EXPERIENCES = [
  {
    key: 'thomasMore2',
  },
  {
    key: 'lhs',
  },
  {
    key: 'thomasMore',
  },
];

